import { get_taxes } from "../helpers/tco-calculator";
import config from "../config.json";
import data from "../data.json";

let initial_total_mileage =
    (Math.round(((config.mileage_init * config.duration_init) / 12 / 10000) * 2) * 10000) / 2;

if (initial_total_mileage >= 160000) {
    initial_total_mileage = 160000;
} else if (initial_total_mileage <= 10000) {
    initial_total_mileage = 10000;
}

const initial_state = {
    raw_initial_price: config.raw_initial_price_init,
    cv: 7,
    rebate: config.rebate_init,
    duration: config.duration_init,
    mileage: config.mileage_init,
    interest_rate: config.interest_rate_init,
    discounted_price: config.raw_initial_price_init * (1 - config.rebate_init / 100),
    vat: config.raw_initial_price_init * (1 - config.rebate_init / 100) * (config.vat / 100),
    net_discounted_price:
        config.raw_initial_price_init * (1 - config.rebate_init / 100) +
        config.rebate_init +
        config.raw_initial_price_init * (1 - config.rebate_init / 100) * (config.vat / 100),
    residual_value:
        (config.raw_initial_price_init *
            data["Valeur de fin de contrat en %"][initial_total_mileage][config.duration_init]) /
        100,

    has_maintenance: config.has_maintenance,
    maintenance: data["Maintenance Forfait"][initial_total_mileage][config.duration_init],

    has_assistance: config.has_assistance,
    assistance: data["Prestations Fixes"][initial_total_mileage][config.duration_init],

    has_tires: config.has_tires,
    tires: data["Pneumatiques Forfait"][initial_total_mileage][config.duration_init],

    has_insurance: config.has_insurance,
    insurance: data["Greenval Tous Risques"][initial_total_mileage][config.duration_init],

    has_taxes: config.has_taxes,
    has_fuel: config.has_fuel,

    total_consumption: undefined,
    fuel_price: config.fuel_price[config.initial_fuel],

    professional_vehicle: false,
    vehicle_fuel: config.initial_fuel,
    co2_emissions: config.emissions[config.initial_fuel],
    vat_level: config.vat,
};

const postProcessState = (next_state, action) => {
    if (action && action.payload.target === "vehicle_fuel") {
        next_state["co2_emissions"] = config.emissions[next_state.vehicle_fuel];
        next_state["fuel_price"] = config.fuel_price[next_state.vehicle_fuel];
    }

    next_state["discounted_price"] = next_state.raw_initial_price * (1 - next_state.rebate / 100);
    next_state["total_consumption"] =
        next_state.vehicle_fuel === "ev"
            ? 0
            : ((next_state.co2_emissions / 1000) *
                  next_state.duration *
                  next_state.mileage *
                  (1 / config.emissions_conversion[next_state.vehicle_fuel])) /
              12;
    next_state["vat"] = !next_state.professional_vehicle
        ? (next_state.discounted_price * next_state.vat_level) / 100
        : 0;

    next_state["net_discounted_price"] = next_state.discounted_price + next_state.vat;

    let total_mileage =
        (Math.round(((next_state.mileage * next_state.duration) / 12 / 10000) * 2) * 10000) / 2;

    if (total_mileage >= 160000) {
        total_mileage = 160000;
    } else if (total_mileage <= 10000) {
        total_mileage = 10000;
    }

    next_state["residual_value"] =
        (next_state.raw_initial_price *
            data["Valeur de fin de contrat en %"][total_mileage][next_state.duration]) /
        100;

    next_state["maintenance"] = Math.round(data["Maintenance Forfait"][total_mileage][next_state.duration]);
    next_state["assistance"] = Math.round(data["Prestations Fixes"][total_mileage][next_state.duration]);
    next_state["tires"] = Math.round(data["Pneumatiques Forfait"][total_mileage][next_state.duration]);
    next_state["insurance"] = Math.round(data["Greenval Tous Risques"][total_mileage][next_state.duration]);

    let next_taxes = get_taxes(next_state)

    next_state["taxes"] = next_taxes;

    return next_state;
};

const reducerData = (state = initial_state, action) => {
    switch (action.type) {
        case "UPDATE_DATA":
            let next_state = { ...state };
            next_state[action.payload.target] = action.payload.value;

            return postProcessState(next_state, action);

        case "RESET_DATA":
            let next_state_reset = { ...state };
            next_state_reset[action.payload.target] = config[action.payload.target + "_init"];

            return postProcessState(next_state_reset, action);

        case "RESET_APP":
            return postProcessState(initial_state, null);

        default:
            return postProcessState(state, null);
    }
};

export default reducerData;



// WEBPACK FOOTER //
// ./src/reducers/reducer-data.js